module.exports = __webpack_public_path__ + "media/images/audio-waves-min-54e2706073c48835b9a52d6c34d2a862.svg";